module.exports = __webpack_public_path__ + "static/waterproof-mattress-protector-2-fdfd4b7ff4a56b60e8b5d6920505456f.webp";